import userReducer, {
  UserState
} from '@portalterreno/nextjs-client/redux/slices/user';
import { UnknownAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

/**
 * TL;DR: Extends the user reducer to handle the HYDRATE action.
 *
 * This reducer exists to handle the HYDRATE action, which is dispatched by
 * next-redux-wrapper. It is necessary to handle this action because the
 * HYDRATE action is dispatched before the root reducer is called, and the
 * root reducer is where the user reducer is called. This means that the user
 * reducer will not be called with the HYDRATE action unless this reducer
 * exists to handle it.
 */
export default function user(
  state: UserState | undefined,
  action: UnknownAction
) {
  if (action.type === HYDRATE && action.payload && state) {
    const payload = action.payload as { user: UserState };

    return userReducer(
      {
        ...state,
        ...(payload.user.name.value && {
          name: {
            ...state.name,
            value: payload.user.name.value
          }
        })
      },
      action
    );
  }

  return userReducer(state, action);
}
